import React from 'react';

import ICO_HEART_2 from 'assets/images/xFrequentlyheart.svg';
import { useTranslation } from 'providers/GILT.provider';

const FrequentlyButton = (props) => {
  const { t } = useTranslation();

  return (
    <button className="more-option-item" onClick={props.onClickFrequentBtn} role="menuitem" tabIndex={0} id="frequently-booked-btn">
      <img src={ICO_HEART_2} style={{ width: '20px', height: '46px' }} alt="Frequently booked services" className="icon" />
      <div>{t('scheduler.booking.frequentlyBookedButton')}</div>
    </button>
  );
};

export default FrequentlyButton;
